export default __webpack_public_path__ + "static/media/favorite_icon.cbc973ad.svg";